import { useNavigate } from '@tanstack/react-router'

import { Button } from '@/components/ui'
import { useToast } from '@/hooks'
import {
  useFilingMutations,
  useFilingsMutating,
} from '@/modules/tools/bankruptcy/hooks'
import type {
  Filing,
  FilingProject,
} from '@/modules/tools/bankruptcy/stores/types'
import { getProjectPath } from '@/utils'
import { Panel } from './Panel'

export const ConvertCard = ({ filing }: { filing: Filing }) => {
  const navigate = useNavigate()
  const mutating = useFilingsMutating()
  const { convertFilingToProject } = useFilingMutations()
  const { errorToast } = useToast()

  const goToProject = (project: FilingProject) =>
    navigate({ to: getProjectPath(project) })

  const project = filing.project
  if (project) {
    return (
      <Panel
        title="Converted to a project"
        hint="This case now lives in its project."
        action={
          <Button theme="outline" onClick={() => goToProject(project)}>
            View project
          </Button>
        }
      />
    )
  }

  const handleConvert = () =>
    convertFilingToProject(filing.id)
      .then((converted) => converted.project && goToProject(converted.project))
      .catch((error) => errorToast('Failed to convert the case', error))

  return (
    <Panel
      title="Ready to open the matter?"
      hint="Turn this case into a full project with its case details and a starter task list."
      action={
        <Button onClick={handleConvert} disabled={mutating}>
          Convert to Project
        </Button>
      }
    />
  )
}
